import React, { Component } from 'react';
import { GET_LIST, GET_MANY } from 'admin-on-rest';

import Welcome from './Welcome';
import MonthlyRevenue from './MonthlyRevenue';
import NbNewOrders from './NbNewOrders';
import PendingOrders from './PendingOrders';
import PendingReviews from './PendingReviews';
import NewCustomers from './NewCustomers';
import restClient from '../restClient';
import { AppBarMobile } from 'admin-on-rest/lib/mui';
import withWidth from 'material-ui/utils/withWidth';
//import restClientFactory from '../rest/restClient';

//const restClient = restClientFactory('http://api-dev.slika.org.il/api', () => window.localStorage.getItem('token'),'');


const styles = {
    /*main: { margin: '2em' },*/
    welcome: { marginBottom: '2em' },
    flex: { display: 'flex' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '2em' },
};

class Dashboard extends Component {
    state = {};

    componentDidMount() {
        const d = new Date();
        d.setDate(d.getDate() - 30);
        
        restClient(GET_LIST, 'Risks/duplicateCard', {
              /*  filter: { date_gte: d.toISOString() },*/
                sort: { field: 'id', order: 'DESC' },
                pagination: { page: 1, perPage: 50 },
            })
            .then(test => {
              /*  console.log('eitan');
                console.log(test);
                this.setState({ test:test.data.hafkadot.data });
                console.log('eitan1');*/
            })
          
       
        restClient(GET_LIST, 'customers', {
              /*  filter: { has_ordered: true, first_seen_gte: d.toISOString() },*/
                sort: { field: 'id', order: 'DESC' },
                pagination: { page: 1, perPage: 30 },
            })
            .then(response => response.data)
            .then(newCustomers => {
                this.setState({ newCustomers });
                this.setState({ nbNewCustomers: newCustomers.reduce(nb => ++nb, 0) })
            })
    }

    render() {
        const {
            nbNewCustomers,
            test,
            nbNewOrders,
            nbPendingReviews,
            newCustomers,
            pendingOrders,
            pendingOrdersCustomers,
            pendingReviews,
            pendingReviewsCustomers,
            revenue,
        } = this.state;
        const { width } = this.props;
        return (
             <div>
                {width === 1 && <AppBarMobile title="איגוד הסליקה הישראלי" />}
                <Welcome style={styles.welcome} />
                <div style={styles.flex}>
                    <div style={styles.leftCol}>
                        
                        <div style={styles.singleCol}>
                            <PendingOrders orders={test} customers={pendingOrdersCustomers} />
                        </div>
                    </div>
                    <div style={styles.rightCol}>
                        <div style={styles.flex}>
                            
                            <NewCustomers nb={nbNewCustomers} visitors={newCustomers} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withWidth()(Dashboard);



// WEBPACK FOOTER //
// ./src/dashboard/Dashboard.js